import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n/TranslationContext";
import Footer from "../../layouts/Footer";

export default function TermsConditions() {
  const { lang, toggleLang } = useTranslation();
  const [theme, setTheme] = useState(
    () => localStorage.getItem("theme") || "dark",
  );

  useEffect(() => {
    localStorage.setItem("theme", theme);
    document.body.classList.remove("theme-light", "theme-dark");
    document.body.classList.add(`theme-${theme}`);
    window.scrollTo(0, 0);
  }, [theme]);

  const toggleTheme = () =>
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));

  const isAr = lang === "ar";

  return (
    <div
      className={`aq-home theme-${theme}`}
      dir={isAr ? "rtl" : "ltr"}
      lang={lang}
    >
      <header className="aq-nav">
        <div className="aq-container aq-nav-inner">
          <Link to="/" className="aq-brand" style={{ textDecoration: "none", color: "inherit" }}>
            <div className="aq-brand-text">
              <span className="aq-brand-name">Aman-QO</span>
              <span className="aq-brand-tag">
                {isAr ? "الأمان الرقمي.. ببساطة" : "Digital Safety, Simplified"}
              </span>
            </div>
          </Link>

          <div className="aq-nav-cta">
            <button className="aq-btn aq-btn-ghost aq-theme-toggle" onClick={toggleLang}>
              {lang === "ar" ? "EN" : "ع"}
            </button>
            <button className="aq-btn aq-btn-ghost aq-theme-toggle" onClick={toggleTheme}>
              {theme === "dark"
                ? isAr ? "فاتح ☀️" : "Light ☀️"
                : isAr ? "داكن 🌙" : "Dark 🌙"}
            </button>
            <Link to="/" className="aq-btn aq-btn-solid" style={{ textDecoration: "none" }}>
              {isAr ? "العودة للرئيسية" : "Back to Home"}
            </Link>
          </div>
        </div>
      </header>

      <section className="aq-section aq-legal-page">
        <div className="aq-container">
          <div className="aq-legal-page-head">
            <span className="aq-pricing-kicker">
              {isAr ? "الشروط والأحكام" : "Terms & Conditions"}
            </span>
            <h1 className="aq-headline">
              {isAr ? "الشروط والأحكام لمنصة Aman-QO" : "Aman-QO Terms & Conditions"}
            </h1>
            <p className="aq-muted">
              {isAr
                ? "توضح هذه الصفحة الشروط المنظمة لاستخدام منصة Aman-QO وخدماتها المتعلقة بفحص الروابط و QR Codes."
                : "This page sets out the terms governing the use of Aman-QO and its services related to link and QR code scanning."}
            </p>
          </div>

          <div className="aq-legal-doc">
            <section className="aq-legal-doc-block">
              <h2>{isAr ? "1. القبول" : "1. Acceptance"}</h2>
              <p>
                {isAr
                  ? "باستخدامك منصة Aman-QO أو التطبيق أو الموقع الإلكتروني أو الإضافة الخاصة بالمتصفح، فإنك توافق على الالتزام بهذه الشروط والأحكام."
                  : "By using the Aman-QO platform, app, website, or browser extension, you agree to be bound by these Terms & Conditions."}
              </p>
            </section>

            <section className="aq-legal-doc-block">
              <h2>{isAr ? "2. وصف الخدمة" : "2. Service Description"}</h2>
              <p>
                {isAr
                  ? "Aman-QO تقدم خدمة تساعد المستخدمين على فحص الروابط و QR Codes وتقييم مستوى الخطورة المحتمل قبل فتحها، مع توعية أمنية وتنبيهات مرتبطة بنتائج الفحص."
                  : "Aman-QO provides a service that helps users scan links and QR codes and assess potential risk before opening them, along with security awareness and alerts based on scan results."}
              </p>
            </section>

            <section className="aq-legal-doc-block">
              <h2>{isAr ? "3. حدود الخدمة" : "3. Service Limitations"}</h2>
              <ul className="aq-list">
                <li>
                  {isAr
                    ? "النتائج استرشادية وتساعد المستخدم في اتخاذ القرار."
                    : "Results are advisory and intended to support user decision-making."}
                </li>
                <li>
                  {isAr
                    ? "الخدمة لا تضمن منع جميع المخاطر أو اكتشاف كل التهديدات بنسبة 100%."
                    : "The service does not guarantee the prevention of all risks or detection of every threat with 100% certainty."}
                </li>
                <li>
                  {isAr
                    ? "يبقى المستخدم مسؤولًا عن قراره النهائي قبل أو بعد فتح الرابط."
                    : "The user remains responsible for any final decision made before or after opening a link."}
                </li>
              </ul>
            </section>

            <section className="aq-legal-doc-block">
              <h2>{isAr ? "4. الحسابات والاشتراكات" : "4. Accounts and Subscriptions"}</h2>
              <ul className="aq-list">
                <li>
                  {isAr
                    ? "قد تتطلب بعض المزايا إنشاء حساب أو الاشتراك في إحدى الباقات المتاحة."
                    : "Some features may require creating an account or subscribing to one of the available plans."}
                </li>
                <li>
                  {isAr
                    ? "يتحمل المستخدم مسؤولية صحة المعلومات المقدمة عند التسجيل."
                    : "The user is responsible for the accuracy of the information provided during registration."}
                </li>
                <li>
                  {isAr
                    ? "أي استخدام غير مصرح به للحساب أو مشاركة بيانات الدخول قد يؤدي إلى تعليق الحساب أو إنهائه."
                    : "Unauthorized use of an account or sharing of login credentials may lead to suspension or termination."}
                </li>
              </ul>
            </section>

            <section className="aq-legal-doc-block">
              <h2>{isAr ? "5. الاستخدام المقبول" : "5. Acceptable Use"}</h2>
              <ul className="aq-list">
                <li>
                  {isAr
                    ? "يُسمح باستخدام المنصة للأغراض القانونية والمشروعة فقط."
                    : "The platform may only be used for lawful and legitimate purposes."}
                </li>
                <li>
                  {isAr
                    ? "يُمنع إساءة استخدام الخدمة أو محاولة التحايل على حدود الباقات أو النظام."
                    : "Misuse of the service or attempts to bypass plan limits or system controls are prohibited."}
                </li>
                <li>
                  {isAr
                    ? "يُمنع استخدام المنصة في أنشطة غير قانونية أو ضارة أو احتيالية."
                    : "The platform must not be used for illegal, harmful, or fraudulent activities."}
                </li>
              </ul>
            </section>

            <section className="aq-legal-doc-block">
              <h2>{isAr ? "6. الدفع والاسترجاع" : "6. Payments and Refunds"}</h2>
              <p>
                {isAr
                  ? "تخضع عمليات الدفع والاسترجاع للسياسات المعلنة داخل المنصة، بما في ذلك شروط الاسترجاع ونسب الاستخدام وحدود الأهلية للاسترداد."
                  : "Payments and refunds are subject to the policies published on the platform, including refund conditions, usage percentages, and eligibility limits."}
              </p>
            </section>

            <section className="aq-legal-doc-block">
              <h2>{isAr ? "7. الملكية الفكرية" : "7. Intellectual Property"}</h2>
              <p>
                {isAr
                  ? "جميع الحقوق المتعلقة بالمنصة، بما في ذلك الاسم التجاري، التصميمات، المحتوى، العلامات، والبرمجيات، مملوكة لـ Aman-QO أو مرخصة لها، ولا يجوز نسخها أو إعادة استخدامها دون إذن."
                  : "All rights related to the platform, including the brand name, designs, content, marks, and software, are owned by or licensed to Aman-QO and may not be copied or reused without permission."}
              </p>
            </section>

            <section className="aq-legal-doc-block">
              <h2>{isAr ? "8. إيقاف أو إنهاء الخدمة" : "8. Suspension or Termination"}</h2>
              <p>
                {isAr
                  ? "يحق لـ Aman-QO تعليق أو تقييد أو إنهاء الوصول إلى الخدمة في حال مخالفة هذه الشروط أو وجود إساءة استخدام أو خطر أمني أو قانوني."
                  : "Aman-QO may suspend, restrict, or terminate access to the service if these terms are violated or if misuse, legal risk, or security risk is detected."}
              </p>
            </section>

            <section className="aq-legal-doc-block">
              <h2>{isAr ? "9. تعديل الخدمات أو الأسعار" : "9. Changes to Services or Pricing"}</h2>
              <p>
                {isAr
                  ? "تحتفظ Aman-QO بالحق في تعديل الخدمات أو المزايا أو الأسعار أو حدود الاستخدام أو هذه الشروط في أي وقت."
                  : "Aman-QO reserves the right to modify services, features, pricing, usage limits, or these terms at any time."}
              </p>
            </section>

            <section className="aq-legal-doc-block">
              <h2>{isAr ? "10. المسؤولية" : "10. Liability"}</h2>
              <p>
                {isAr
                  ? "إلى الحد الذي يسمح به القانون، لا تتحمل Aman-QO مسؤولية الأضرار أو الخسائر الناتجة عن استخدام الخدمة أو الاعتماد على نتائج الفحص وحدها دون اتخاذ احتياطات إضافية."
                  : "To the extent permitted by law, Aman-QO shall not be liable for damages or losses arising from use of the service or reliance solely on scan results without additional precautions."}
              </p>
            </section>

            <section className="aq-legal-doc-block">
              <h2>{isAr ? "11. التواصل" : "11. Contact"}</h2>
              <p>
                {isAr
                  ? "لأي استفسارات تتعلق بالشروط والأحكام، يمكن التواصل عبر البريد الإلكتروني:"
                  : "For any questions regarding these Terms & Conditions, you may contact us by email:"}
              </p>
              <p>
                <b>amanqo.hq@gmail.com</b>
              </p>
            </section>
          </div>
        </div>
      </section>

      <Footer
        lang={lang}
        t={(key) => {
          const map = {
            "footer.rights": isAr ? "جميع الحقوق محفوظة." : "All rights reserved.",
            "nav.about": isAr ? "عن الشركة" : "About",
          };
          return map[key] || key;
        }}
      />
    </div>
  );
}